<template>
  <div class="clearfix">
    <a-upload
      v-model:file-list="fileList"
      @preview="handlePreview"
      :customRequest="customRequest"
      @change="change"
      :multiple="number === 1 ? false : true"
      :accept="props.accept"
      :disabled="props.disabled"
      :before-upload="beforeUpload"
      :showUploadList="
        props.showList && {
          showPreviewIcon: true,
          showRemoveIcon: true,
          showDownloadIcon: true,
        }
      "
    >
      <div
        v-if="(fileList.length < number && !props.disabled) || !props.showList"
      >
        <slot>
          <a-button>{{ props.btnText }}</a-button>
        </slot>
      </div>
      <template #itemRender="{ file, actions }">
        <a-space>
          <span :style="file.status === 'error' ? 'color: red' : ''">
            {{ file.name }}
          </span>
          <a-button @click="actions.download" size="small">下载</a-button>
          <a-button
            @click="actions.remove"
            danger
            size="small"
            v-if="!props.disabled"
          >
            删除
          </a-button>
        </a-space>
      </template>
    </a-upload>
  </div>
</template>
<script setup>
  import { reactive, ref, toRaw, defineProps, defineEmits, watch } from 'vue'
  import { baseURL } from '@/config'
  import axios from 'axios'
  import { getAccessToken } from '@/utils/auth'
  import { message } from 'ant-design-vue'
  const emit = defineEmits(['update:modelValue', 'change', 'uploadSuccess', 'error', 'beforeUpload', 'uploadFailed'])
  const props = defineProps({
    modelValue: {
      required: true, //是否必传
    },
    label: {
      type: String, // 参数类型
      required: true, //是否必传
    },
    value: {
      required: true, //是否必传
    },
    placeholder: {
      type: String, // 参数类型
    },
    'allow-clear': {
      default: true,
    },
    number: {
      default: 1,
    },
    accept: {
      default: '*/*', // image/*
    },
    showList: {
      default: true,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    url: {
      default: '/pre_upload/api/upload/files',
    },
    fileField: {
      default: 'file[]',
    },
    btnText: {
      default: '+上传',
    },
    handelBeforeUpload: {
      default: false,
    },
  })
  const fileList = ref(initFileList(props.modelValue))

  function beforeUpload(e) {
    if (!props.handelBeforeUpload) return true
    emit('beforeUpload', e)
    return false
  }

  function initFileList(list) {
    if (!list?.length) return []
    if (props.number === 1) list = list ? [list] : []
    if (list.constructor === String) list = [list]
    return list.map((item) => {
      if (item.constructor === String)
        return { status: 'done', url: item, name: getFileName(item) }
      if (item.constructor === Object)
        return {
          url: item.url,
          id: item.id,
          status: 'done',
          name: getFileName(item.url),
        }
    })
  }

  function change(data) {
    const hasUploading = data.fileList.some(
      (item) => item.status === 'uploading'
    )
    if (hasUploading) return 'uploading'
    
    // 检查是否有上传失败的文件
    const hasFailed = data.fileList.some(
      (item) => item.status === 'error'
    )
    
    if (hasFailed) {
      const failedFiles = data.fileList.filter(
        (item) => item.status === 'error'
      )
      handleUploadFailed(failedFiles)
    }
    
    const doneList = data?.fileList?.length
      ? data.fileList.filter((item) => item.status === 'done')
      : []
    
    if (doneList.length > 0) {
      handleUploadSuccess(doneList)
    }
    
    const formatList = doneList.map((item) => item.url || item?.response?.file)
    fileList.value = initFileList(
      props.number === 1 ? formatList[0] : formatList
    )
    
    // 向父组件发送change事件
    emit('change', data)
  }
  
  // 处理上传成功
  function handleUploadSuccess() {
    console.log('文件上传成功',)
    emit('uploadSuccess')
  }
  
  // 处理上传失败
  function handleUploadFailed(files) {
    console.log('文件上传失败:', files)
    emit('uploadFailed', files)
  }

  watch(fileList, function dataChange() {
    const hasUploading = fileList.value.some(
      (item) => item.status === 'uploading'
    )
    if (hasUploading) return
    emit('update:modelValue', getUrl(fileList.value))
  })

  function getUrl(fileList) {
    if (props.number === 1) {
      return (fileList[0]?.id ? fileList[0] : fileList[0]?.url) || ''
    }
    return fileList
  }

  async function customRequest({ file, onError, onSuccess }) {
    const formData = new FormData()
    try {
      formData.append(props.fileField, file)
        const { data } = await axios
          .post(baseURL + props.url, formData, {
            headers: {
              Authorization: getAccessToken(),
              'Content-Type': 'multipart/form-data',
            },
          })
        console.log(data, '错误')
        
        if (data?.success) {
          // 调用上传成功处理方法
          handleUploadSuccess()
          onSuccess()
          message.success('文件上传成功')
        } else {
          // 处理返回数据异常的情况
          const errorMsg = data?.msg || '上传失败：服务器未返回文件路径'
          message.error(errorMsg)
          emit('error', data)
          emit('uploadFailed', [{ ...file, status: 'error', error: errorMsg }])
          onError({
            err: errorMsg,
          })
        }
    } catch (err) {
      // 处理网络错误或其他异常
      console.log(err , 'err')
      console.log(err.response, 'err.response')
      const errorMsg = err.response?.data?.msg || '网络错误，上传失败'
      message.error(errorMsg)
      emit('error', err)
      emit('uploadFailed', [{ ...file, status: 'error', error: errorMsg }])
      onError({
        err: err,
      })
    }
  }
  function getFileName(url) {
    if (!url) return ''
    const splitArr = url.split('/')
    return splitArr[splitArr.length - 1]
  }
  const handlePreview = async (file) => {
    console.log('🚀  handlePreview  file:', file)
  }
</script>
<style scoped>
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>
